<template>
  <div>


    <div style="display: none;">
        
    </div>

  </div>
</template>
<script>

export default {
  components: {},
  mounted() {
    // 手动写全部dat文件名，放在public/download/下面
    const fileList = [
      "/download1/GameData.dat",
      "/download1/GameFrameworkVersion.dat",
      "/download1/Resources.dat",
      "/download1/UI.dat"
    ];

    fileList.forEach(url => {
      const a = document.createElement("a");
      a.href = url;
      // 下载后的文件名，取路径最后一段
      a.download = url.split("/").pop();
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    })
  }
}
</script>